import {lazy} from '@aboutyou/lazy-imports';

export const SimilarProductsPage = lazy(
  () =>
    import('./SimilarProductsPage.eager').then(mod => ({
      default: mod.SimilarProductsPageEager,
    })),
  {
    aboveTheFold: true,
  },
);
